import React, { useCallback } from 'react';
import { ConfirmModal } from '../ConfirmModal';
import { useTranslation } from 'react-i18next';
import { competitionFinalize, getRandomFact } from '../../../queries';

interface IConfirmFinalizeModal {
  showConfirmFinilize: boolean;
  setShowConfirmFinilize: (data: boolean) => void;
  setShowHippoFactModal: (data: boolean) => void;
  setShowResultModal: (data: boolean) => void;
}

export const ConfirmFinalizeModal: React.FC<IConfirmFinalizeModal> = ({
  showConfirmFinilize,
  setShowConfirmFinilize,
  setShowHippoFactModal,
  setShowResultModal,
}) => {
  const { t } = useTranslation();

  const finishGame = useCallback(() => {
    getRandomFact();
    competitionFinalize();
  }, []);

  const onFinishClick = useCallback(() => {
    finishGame();
    setShowConfirmFinilize(false);
    setShowResultModal(false);
    setShowHippoFactModal(true);
  }, [
    finishGame,
    setShowConfirmFinilize,
    setShowHippoFactModal,
    setShowResultModal,
  ]);

  const onClose = useCallback(() => {
    setShowConfirmFinilize(false);
  }, [setShowConfirmFinilize]);

  return (
    <ConfirmModal
      title={t('game.confirm_finalize_title')}
      subtitle={t('game.confirm_finalize_subtitle')}
      closeButtonTitle={t('common.no')}
      submitButtonTitle={t('common.yes')}
      onClose={onClose}
      isOpen={showConfirmFinilize}
      onSubmit={onFinishClick}
      backgroundIllustrationName="HippoWithRoad"
      titleSize="24px"
    />
  );
};
